export default __webpack_public_path__ + "static/media/pexels-tima-miroshnichenko-5355919.bc647852.jpg";